import axios from 'axios';
import store from '@/store';
import Auth from '@/authentication';

export const $http = axios.create({
    baseURL: process.env.VUE_APP_API_URL + '/admin',
});

$http.interceptors.request.use((config) => {
    config.headers['Authorization'] = store.getters.auth.idToken || '';
    return config;
});

$http.interceptors.response.use(
    (config) => {
        return config;
    },
    (error) => {
        if (error.response.status === 403) {
            Auth.logout();
        }
        return Promise.reject(error);
    }
);
